import CustomHorizontalSpace from "../../Assistants/SpaceAssistant";
import {Grid} from "@mui/material";
import bg from "../../SVG/Circle-270.svg";
import PropertyCard from "../../Cards/PropertyCard";
import {Colors} from "../../../resources/Colors";
import React from "react";

function OverViewImmunoClustPropsColumn() {
    return <>
        <Grid container>
            <CustomHorizontalSpace space={100}/>
            <div style={{display:"flex" , alignItems:"flex-start" , flexDirection:"column" , marginLeft:'10%' , marginRight:'10%'}}>
                <h1>iCAP</h1>
                <div className={"line"}></div>
                <h2> Clustering, Population Identification and Quantification
                </h2>
            </div>
            <CustomHorizontalSpace space={100}/>
            <Grid container direction={'column'} style={{backgroundImage: `url(${bg})` ,backgroundRepeat:'no-repeat', backgroundPosition:'center', justifyContent:'space-between', alignItems:"center" , display:"flex"}} >
                <Grid item className="property-card-container" >
                    <PropertyCard title={"CELL-EVENT clustering"} icon={"fa-solid fa-magnifying-glass fa-3x"}  color={Colors.bioretisBlue} text={"Detection of groups of cells with similar staining characteristics in an individual sample"}  />
                </Grid>
                <Grid item className="property-card-container">
                    <PropertyCard title={"META clustering"} icon={"fa-sharp fa-regular fa-circle-nodes fa-3x"} fontFamily={"sharp"} color={Colors.bioretisBlue} text={"Matching of cell populations (clusters) with similar staining characteristics between multiple samples"}  />
                </Grid>
                <Grid item className="property-card-container">
                    <PropertyCard title={"META-CLUSTER-Annotation"} icon={"fa-regular fa-bars-sort fa-3x"} color={Colors.bioretisBlue} text={"Staining dependent hierarchical sorting and characterization of cell (sub-) populations"}  />
                </Grid>
                <Grid item className="property-card-container">
                    <PropertyCard title={"CELL-TYPE Quantification"} icon={"fa-light fa-chart-tree-map fa-3x"} color={Colors.bioretisBlue} text={"Absolute and relative quantification of populations by numbers of cells per cluster, variability of markers per cluster and comparison with healthy reference"}  />
                </Grid>
            </Grid>





        </Grid>


</>



} export default OverViewImmunoClustPropsColumn;